import { AccessLevel, Section } from 'app/frontend/types/custom'
import { encodePath } from '../helpers'
import { hasAccessToContent } from './ProtectedContent'

export type MenuItem = {
  name: string | React.ReactNode
  path: string
  width: number
  exact?: boolean
  section?: Section
  requirement?: AccessLevel
  alwaysVisible?: boolean
  children?: (Omit<MenuItem, 'children' | 'width'> & { width?: number })[]
}

export const normalizePath = (path: string) => {
  return path === '/' ? path : path.replace(/\/+$/, '')
}

export const isMenuPathActive = (
  currentPath: string,
  path: string,
  exact?: boolean,
) => {
  const normalizedCurrentPath = normalizePath(currentPath)
  const encodedPath = normalizePath(encodePath(path))

  return exact
    ? normalizedCurrentPath === encodedPath
    : normalizedCurrentPath === encodedPath ||
        normalizedCurrentPath.startsWith(`${encodedPath}/`)
}

export const filterMenuItemsByAccess = (
  menuItems: MenuItem[],
  guild?: wowaudit.Guild,
  teamReference?: wowaudit.TeamReference,
) => {
  return menuItems.filter((item) => {
    return hasAccessToContent(
      item.alwaysVisible ? 'member' : item.requirement ?? 'none',
      item.section ?? 'base',
      guild,
      teamReference,
    ).hasAccess
  })
}

export const filterChildrenByAccess = (
  item: MenuItem,
  guild?: wowaudit.Guild,
  teamReference?: wowaudit.TeamReference,
) => {
  return (
    item.children?.filter((child) => {
      return hasAccessToContent(
        child.requirement ?? item.requirement ?? 'none',
        child.section ?? item.section ?? 'base',
        guild,
        teamReference,
      ).hasAccess
    }) ?? []
  )
}
